import { Component, OnInit, Inject, HostListener, inject } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { RemarkService } from '../../../services/remark.service';
import { take } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'tt-send-remark-email-dialog',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './send-remark-email-dialog.component.html',
  //!not the usual scss
  styleUrls: ['../send-map-remark-panel/send-map-remark-panel.component.scss'],
  standalone: true
})
export class SendRemarkEmailDialogComponent implements OnInit {
  formGroup: UntypedFormGroup;
  private subscriptions: Subscription = new Subscription();
  private messageType: string = 'email';//remark or email
  public csrf: string = '';
  public loading: boolean;
  public msgIsSent: boolean;
  public errorIsSent: boolean;
  public error: string;
  public formdata: boolean;
  private recaptchaToken: string = null;
  public data = inject<any>(MAT_DIALOG_DATA);

  constructor(
    private translateService: TranslateService,
    private remarkService: RemarkService,
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<SendRemarkEmailDialogComponent>
  ) { }
  ngOnInit(): void {
    //on ios requesting the recaptcha token via iframe
    //to avoid unauthorized errors
    if (Capacitor.isNativePlatform()) {
      window.addEventListener('message', (event) => {
        if (event.data?.recaptchaToken) {
          this.recaptchaToken = event.data.recaptchaToken;
          // console.log('Received reCAPTCHA token:', this.recaptchaToken);
        }
      });
      //execute captcha request 
      const iframe = document.getElementById('recaptcha-frame') as HTMLIFrameElement;
      iframe?.contentWindow?.postMessage('run-recaptcha', '*');
    }
    this.createForm();
    this.loading = false;
    this.msgIsSent = false;
    if (this.data.validateOnOpen) this.formGroup.markAllAsTouched();
    this.dialogRef.beforeClosed().pipe(take(1)).subscribe(() => {
      this.dialogRef.close([this.formGroup.value, this.formGroup.touched])
    });
  }

  closeDialog() {
    this.dialogRef.close(this.formGroup.dirty);
  }

  createForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.formGroup = this.formBuilder.group({
      'firstName': [this.data.firstName, [Validators.maxLength(40)]],
      'lastName': [this.data.lastName, [Validators.maxLength(40)]],
      'email': [this.data.email, [Validators.required, Validators.pattern(emailregex)]],
      'message': [this.data.message, [Validators.required, Validators.maxLength(2000)]],//, Validators.minLength(5),
    });
  }

  get firstName() {
    return this.formGroup.get('firstName') as UntypedFormControl
  }
  get lastName() {
    return this.formGroup.get('lastName') as UntypedFormControl
  }

  getErrorEmail() {
    return this.formGroup.get('email').hasError('required') ? 'general.validation.required' :
      this.formGroup.get('email').hasError('pattern') ? 'general.validation.email' : ''
  }

  getErrorMessage() {
    return this.formGroup.get('message').hasError('required') ? 'general.validation.required' :
      this.formGroup.get('message').hasError('maxlength') ? 'general.validation.maxlength' : ''
  }

  public onSubmit(form) {

    this.loading = true;
    let data = form;
    data.languageCode = this.translateService.currentLang.toLowerCase();
    this.subscriptions.add(
      this.remarkService.sendAppRemark(data, this.recaptchaToken).subscribe(
        (response) => {
          console.log('dialog response', response)
          this.loading = false;
          this.msgIsSent = true;
          this.formGroup.markAsPristine();
          this.formGroup.markAsUntouched();
        },
        (error) => {
          this.loading = false;
          this.errorIsSent = true;
          this.error = this.translateService.instant('general.http-errors.' + error);
        }
      )
    );
  }
}
